import { render, staticRenderFns } from "./GridAside.vue?vue&type=template&id=4fccfbee&"
import script from "./GridAside.vue?vue&type=script&lang=js&"
export * from "./GridAside.vue?vue&type=script&lang=js&"
import style0 from "./GridAside.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports